import { useCallback, useMemo } from 'react'
import { useAppNavigation } from 'lib/routing/useAppNavigation'
import { useLocation } from 'react-router-dom'
import useGlobalSearchVerticals from './useGlobalSearchVerticals'

export const DATE_SELECT_OPTION = 'dateSelect'

interface SearchVerticalToggleOptions {
  withDateSelect?: boolean
  search?: string
}

type ReturnType = {
  openedSearchVertical: App.SearchVertical | undefined
  toggleSearchVertical: (searchVertical: App.SearchVertical | 'none', options?: SearchVerticalToggleOptions) => void
  option: string | undefined
}

export default function useGlobalSearchURLHashVertical(): ReturnType {
  const navigation = useAppNavigation()
  const location = useLocation()
  const searchVerticals = useGlobalSearchVerticals()
  const { openedSearchVertical, option } = useMemo(() => {
    if (!location.hash.startsWith('#search_')) {
      return { openedSearchVertical: undefined, option: undefined }
    }
    const [, searchVerticalFromHash, option] = location.hash.split('_')
    if (!searchVerticals.some((vertical) => vertical.vertical === searchVerticalFromHash)) {
      return { openedSearchVertical: undefined, option: undefined }
    }
    return { openedSearchVertical: searchVerticalFromHash as App.SearchVertical, option }
  }, [location.hash, searchVerticals])

  const toggleSearchVertical = useCallback((
    searchVertical: App.SearchVertical | 'none',
    options?: SearchVerticalToggleOptions,
  ) => {
    if (searchVertical === 'none') {
      navigation.replace({ ...location, hash: '' })
    } else {
      let hash = `search_${searchVertical}`
      let search = location.search
      if (options?.withDateSelect) {
        hash += `_${DATE_SELECT_OPTION}`
      }
      if (options?.search) {
        search = options.search
      }
      navigation.replace({ ...location, hash, search })
    }
  }, [navigation, location])

  return { openedSearchVertical, toggleSearchVertical, option }
}
